import script from "./CalendarEditJa.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarEditJa.vue?vue&type=script&setup=true&lang=js"

import "./CalendarEditJa.vue?vue&type=style&index=0&id=d5716e24&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5716e24"]])

export default __exports__